
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/ai-driven-development",
      function () {
        return require("private-next-pages/cases/ai-driven-development/index.tsx");
      }
    ]);
  